goog.provide("shadow.js.shim.module$scheduler");
goog.provide("module$shadow_js_shim_module$scheduler");
shadow.js.shim.module$scheduler = shadow.js.nativeProvides["scheduler"] = shadow$bridge("scheduler");
module$shadow_js_shim_module$scheduler.default = shadow.js.shim.module$scheduler;
